//libs
import { useContext, useMemo } from 'react';

//components
import StoresList from './stores-list';
import ArrowDownYel from '../images/arrow-down-yel.svg';
import { StoresContext } from '../../../../App';
import CitiesColumns from './cities-columns';
import ActiveCity from './active-city';
import MapSection from './map-section';

//helpers
import { compareStrings } from '../../../../util/compareStrings';
import { buildColumnStructure } from '../helpers/buildColumnStructure';

//hooks
import { useColumnResize } from '../hooks/useColumnResize';

export default function CitiesList(
    {
        fullStoresCounters,
    }: {
        fullStoresCounters: Map<string, number>,
    }
){
    const { 
        setLocationFilters,
        locationFilters,
        stores,
    } = useContext(StoresContext);

    const setCityWithRegion = (city: string, region: string) => {
        setLocationFilters((values) => ({ ...values, city, region }));
    };

    const unsetCountry = () => {
        setLocationFilters((values) => ({ ...values, country: '', region: '', city: '' }));
    };

    const data = useMemo(() => {
        let storesCounter = 0;
        const citiesMap: { [key: string]: { city: string, region: string | null }} = {}; 

        for (const s of stores) {
            if(s.country === locationFilters.country) {
                storesCounter++;
            }

            if (
                s.city &&
                s.country === locationFilters.country                
            ) {

                if(locationFilters.region && s.region !== locationFilters.region){
                    continue;
                }

                if(!citiesMap[s.city]) {
                    citiesMap[s.city] = { city: s.city, region: s.region };
                }
            }
        }

        const preparedCities = Object.values(citiesMap).sort((itemA, itemB) => compareStrings(itemA.city, itemB.city));

        return {
            storesCounter,
            list: preparedCities,
        };
    }, [stores, locationFilters]);


    const [columnCount] = useColumnResize();

    const storesCounterTemplate = `(${data.storesCounter})`;
    const isShowCitiesFilter = Number(fullStoresCounters.get(locationFilters.country) ?? 0) > 10;
    const isSkipCityCheck = !isShowCitiesFilter;
    const countryTitleTemplate = locationFilters.region ? `${locationFilters.country}, ${locationFilters.region}` : locationFilters.country;

    return locationFilters.country ? (
        <>
            <div className="feature-filter-block cities-filter-block">
                <div className="cities-filter-block__header"> 
                    <div className="cities-filter-block__title" onClick={() => unsetCountry()}>
                        <img
                            src={ArrowDownYel}
                            alt="arrow-down"
                        />
                        {countryTitleTemplate}
                        <span className="cities-filter-block__counter">{storesCounterTemplate}</span>
                    </div>
                </div>
                {isShowCitiesFilter && (
                    <div>
                        <div className="cities-filter-block__list cities-filter">
                            <div className="cities-filter__list cities-filter-list">
                                {
                                    !locationFilters.city ?
                                        <CitiesColumns columnsStructure={buildColumnStructure(data.list ?? [], columnCount)} setCityWithRegion={setCityWithRegion} /> :
                                        <ActiveCity city={locationFilters.city} setCityWithRegion={setCityWithRegion} />
                                }
                            </div>
                        </div>
                    </div>
                )}
                <StoresList country={locationFilters.country} city={locationFilters.city}  isSkipCityCheck={isSkipCityCheck}/>
                <MapSection />
            </div>
            
        </>
    ) : null;   
};
